import { render, staticRenderFns } from "./BundleProps.vue?vue&type=template&id=846037fa&scoped=true&"
import script from "./BundleProps.vue?vue&type=script&lang=js&"
export * from "./BundleProps.vue?vue&type=script&lang=js&"
import style0 from "./BundleProps.vue?vue&type=style&index=0&id=846037fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846037fa",
  null
  
)

export default component.exports